/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import {
  calculateHours,
  checkUserAccess,
  convertTime,
  formatTo12HourTime,
} from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function ExtraWork() {
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    activeTab: 1,
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    filterData: "",
    month: "",
    extraWorkList: [],
    siteList: [],
    officeList: [],
    staffType: "1",
    // myAttendance: "false",
    searchQuery: "",
    siteId: filterDetails?.siteId,
    officeType: "",
    companyId: "",
    attendanceType: "",
    attendanceStatus: "",
    sortByDate: [
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    companyList: [],
    companyIsLoading: false,
    isInitial: true,
    isLoadingSite: false,
  });
  const userDetails = useSelector((state) => state.root.userDetails);
  const timeoutId = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    GetExtraWork(pageStates?.currentPage);
  }, [
    pageStates?.currentPage,
    pageStates?.staffType,
    pageStates.searchQuery,
    pageStates.attendanceStatus,
    pageStates.attendanceType,
    filterDetails?.siteId,
    pageStates.officeType,
    pageStates?.sortByDate,
    pageStates.pageSize,
    filterDetails?.companyId,
    filterDetails?.orderBy,
  ]);

  useEffect(() => {
    GetCompanyList();
  }, []);

  const GetExtraWork = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_extra_work +
      "?" +
      MainFilterHandler({
        ...pageStates,
        orderBy: filterDetails?.orderBy,
        siteId: pageStates.activeTab == 1 ? "" : pageStates?.siteId,
        companyId: filterDetails?.companyId,
      });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.extraWork?.map((item) => ({
          ...item,
          empNameWithImage: item?.user?.name + "##" + item?.user?.profilePhoto,
          startDate: item?.startDate
            ? moment(item?.startDate).format("DD/MM/YYYY")
            : "--",
          endDate: item?.endDate
            ? moment(item?.endDate).format("DD/MM/YYYY")
            : "--",
          departmentName: item?.user?.department?.name,
          officeName: item?.user?.site?.name,
          siteName: item?.user?.usersites?.[0]?.site?.name,
          startTime: item?.startDate && formatTo12HourTime(item?.startDate),
          endTime: item?.endDate && formatTo12HourTime(item?.endDate),
          totalDuration:
            item?.startDate && calculateHours(item?.startDate, item?.endDate),
        }));
        setPageStates((pre) => ({
          ...pre,
          extraWorkList: newData,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const toggleTab = (tab) => {
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        staffType: "1",
        activeTab: tab,
        currentPage: 1,
        companyId: "",
        siteId: "",
      }));
      // GetSiteList(tab);
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          companyId: "",
        })
      );
      setPageStates((prev) => ({
        ...prev,
        staffType: "0",
        activeTab: tab,
        currentPage: 1,
        companyId: "",
        siteId: filterDetails?.siteId,
      }));
      GetSiteList();
    }
  };

  const HandleUpdateAttendance = (data) => {
    let newStatus;
    if (data?.status == 0) {
      newStatus = 1;
    } else if (data?.status == 1) {
      newStatus = 0;
    } else if (data?.status == 2) {
      newStatus = 1;
    }
    const submitData = {
      type: "attendance",
      id: data?.id,
      status: newStatus,
    };
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.user_status_update;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetExtraWork(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const TableHeadingOffice = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "departmentName", label: "Department" },
    { value: "officeName", label: "Office" },
    { value: "startDate", label: "Start Date" },
    { value: "startTime", label: "Start Time" },
    { value: "endDate", label: "End Date" },
    { value: "endTime", label: "End Time" },
    { value: "totalDuration", label: "Total Duration" },
  ];

  const TableHeadingSite = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "departmentName", label: "Department" },
    { value: "siteName", label: "Site" },
    { value: "startDate", label: "Start Date" },
    { value: "startTime", label: "Start Time" },
    { value: "endDate", label: "End Date" },
    { value: "endTime", label: "End Time" },
    { value: "totalDuration", label: "Total Duration" },
  ];

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      const API =
        apiUrl.get_site +
        `?pageSize=100` +
        (companyId ? `&companyId=${companyId}` : "") +
        (searchQuery ? `&search=${searchQuery}` : "");

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.id,
              label: item?.name,
            }));

            const siteId = response.data?.site?.some(
              (item) => item?.id == filterDetails?.siteId
            );
            setPageStates((prev) => ({
              ...prev,
              ...(siteId ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const GetCompanyList = (inputValue = null) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };

      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const sortHandler = (data, type) => {
    // console.log("DAAAAA", data);
    setPageStates((prevState) => ({
      ...prevState,
      ...(!type && { attendanceType: data?.attendanceType }),
      ...(!type && { attendanceStatus: data?.attendanceStatus }),
      ...(type === "site" && { siteId: data?.site }),
      ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type == "site" && { siteId: data?.site }),
        ...(type === "companyId" && { companyId: data?.companyId }),
      })
    );
    if (pageStates?.activeTab === 2 && type == "companyId") {
      GetSiteList(data?.companyId);
    }
  };

  const sortList = {
    attendanceStatus: [
      { value: "", label: "Select Attendance Status" },
      { value: 1, label: "Present" },
      { value: 0, label: "Absent" },
      { value: 2, label: "Pending" },
      { value: 3, label: "On Leave" },
    ],
    attendanceType: [
      { value: "", label: "Select Attendance Type" },
      { value: "odRequest", label: "OD Request" },
      { value: "arRequest", label: "AR equest" },
      { value: "general", label: "General" },
      { value: "leave", label: "Leave" },
    ],
    ...(pageStates.siteList && { site: pageStates.siteList }),
    companyList: pageStates?.companyList,
  };

  const sortListOffice = {
    attendanceStatus: [
      { value: "", label: "Select Attendance Status" },
      { value: 1, label: "Present" },
      { value: 0, label: "Absent" },
      { value: 2, label: "Pending" },
      { value: 3, label: "On Leave" },
    ],
    attendanceType: [
      { value: "", label: "Select Attendance Type" },
      { value: "odrequest", label: "OD Request" },
      { value: "arrequest", label: "AR equest" },
      { value: "general", label: "General" },
      { value: "leave", label: "Leave" },
    ],
    // ...(pageStates.officeList && { office: pageStates.officeList }),
    companyList: pageStates?.companyList,
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Extra Work"}
          // buttonText={"Apply Leave"}
          // buttonIcon={<PlusIcon />}
          // buttonLink={RoutesLink?.add_customer}
          // clickHandler={toggleModal}
          dateChangeHandler={dateChangeHandler}
        />
        <Nav tabs className="nav nav-tabs border-0 mb-4">
          <NavItem className="nav-item">
            <NavLink
              className={
                pageStates?.activeTab === 1
                  ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                  : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab(1)}
            >
              Office Staff Extra Work
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                pageStates?.activeTab === 2
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab(2)}
            >
              Site Staff Extra Work
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={pageStates?.activeTab}>
          <TabPane tabId={1}>
            <Fade in={pageStates?.activeTab === 1} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    filterArray={sortListOffice}
                    sortHandler={sortHandler}
                    handleSearch={handleSearchChange}
                    handleData={sortHandler}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    pageStates={pageStates}
                    tableDataForExport={pageStates?.extraWorkList}
                    exportFileName={"Office_Staff_Extrawork_Data"}
                    getCompany={GetCompanyList}
                    exportColumns={[
                      "empName",
                      "departmentName",
                      "officeName",
                      "startDate",
                      "startTime",
                      "endDate",
                      "endTime",
                      "totalDuration",
                    ]}
                  />
                  <CommonTable
                    TableHeading={TableHeadingOffice}
                    TableData={pageStates?.extraWorkList}
                    currentPage={pageStates?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={pageStates?.totalPages}
                    count={pageStates?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={pageStates.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={2}>
            <Fade in={pageStates?.activeTab === 2} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    filterArray={sortList}
                    sortHandler={sortHandler}
                    handleSearch={handleSearchChange}
                    handleData={sortHandler}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    pageStates={pageStates}
                    tableDataForExport={pageStates?.extraWorkList}
                    exportFileName={"Site_Staff_Extrawork_Data"}
                    exportColumns={[
                      "empName",
                      "departmentName",
                      "siteName",
                      "startDate",
                      "startTime",
                      "endDate",
                      "endTime",
                      "totalDuration",
                    ]}
                    getCompany={GetCompanyList}
                    getSite={GetSiteList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingSite}
                    TableData={pageStates?.extraWorkList}
                    currentPage={pageStates?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={pageStates?.totalPages}
                    count={pageStates?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={pageStates.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
    </>
  );
}
